'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiImageUrl = exports.imageUrl = exports.baseUrl = exports.parseText = exports.isValidJSON = undefined;

var _client = require('../client');

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidJSON = exports.isValidJSON = function isValidJSON(json) {
  try {
    JSON.parse(json);
    return true;
  } catch (error) {
    return false;
  }
};

var parseText = exports.parseText = function parseText() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var content = text.replace(/\n/g, ' ');

  if (isValidJSON(content)) {
    return JSON.parse(content).map(parseTextSection).join(' ');
  }

  return text;
};

var parseTextSection = function parseTextSection() {
  var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  switch (section.type) {
    case 'paragraph':
      return (0, _get2.default)(section, 'nodes.0.ranges.0.text', '');
    case 'header':
      return (0, _get2.default)(section, 'text', '');
    default:
      return '';
  }
};

var baseUrl = exports.baseUrl = function baseUrl() {
  var subdomain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'www';

  return 'https://' + subdomain + ((0, _client.isStaging)() ? '.staging' : '') + '.justgiving.com';
};

var imageUrl = exports.imageUrl = function imageUrl(image) {
  var template = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CrowdfundingOwnerAvatar';

  return image ? baseUrl('images') + '/image/' + image + '?template=' + template : null;
};

var apiImageUrl = exports.apiImageUrl = function apiImageUrl(slug) {
  var template = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CrowdfundingOwnerAvatar';
  return _client.servicesAPI.defaults.baseURL + '/v1/justgiving/pages/' + slug + '/image?template=' + template;
};